var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { customFetch } from "@filadd/phi-plus-core";
import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { NOTIFICATIONS_API_BASE_PATH } from "./constants";
import { useNotificationCount } from "./useNotificationCount";
const markNotificationSeenFactory = ({ baseURL, authToken, locale } = {}) => (notificationsIds) => __awaiter(void 0, void 0, void 0, function* () {
    if (baseURL == null) {
        throw new Error("baseURL in meta required");
    }
    const body = { notifications_ids: notificationsIds };
    return customFetch(`${NOTIFICATIONS_API_BASE_PATH}/seen/`, {
        baseURL,
        authToken,
        locale,
        body,
    });
});
export const useMarkNotificationSeen = (infiniteQueryKey, updateNotificationCount = false) => {
    var _a;
    const queryClient = useQueryClient();
    const notificationCountQueryKey = useNotificationCount.generateKey();
    return useMutation({
        mutationFn: markNotificationSeenFactory((_a = queryClient.getDefaultOptions().mutations) === null || _a === void 0 ? void 0 : _a.meta),
        onMutate: (notificationId) => {
            const notificationIds = Array.isArray(notificationId)
                ? notificationId
                : [notificationId];
            queryClient.setQueriesData({ queryKey: infiniteQueryKey }, (oldData) => oldData != null
                ? Object.assign(Object.assign({}, oldData), { pages: oldData.pages.map((page) => page.map((notification) => notificationIds.includes(notification.id)
                        ? Object.assign(Object.assign({}, notification), { seen: true }) : notification)) }) : oldData);
            let previousNotificationCount;
            if (updateNotificationCount) {
                previousNotificationCount = queryClient.getQueryData(notificationCountQueryKey);
                queryClient.setQueryData(notificationCountQueryKey, (oldData) => Math.max(0, (oldData !== null && oldData !== void 0 ? oldData : 0) - notificationIds.length));
            }
            return {
                previousNotificationCount,
            };
        },
        onError: (error, notificationId, context) => {
            const notificationIds = Array.isArray(notificationId)
                ? notificationId
                : [notificationId];
            queryClient.setQueriesData({ queryKey: infiniteQueryKey }, (oldData) => oldData != null
                ? Object.assign(Object.assign({}, oldData), { pages: oldData.pages.map((page) => page.map((notification) => notificationIds.includes(notification.id)
                        ? Object.assign(Object.assign({}, notification), { seen: false }) : notification)) }) : oldData);
            if (context === null || context === void 0 ? void 0 : context.previousNotificationCount) {
                queryClient.setQueryData(notificationCountQueryKey, context.previousNotificationCount);
            }
        },
    });
};
//# sourceMappingURL=useMarkNotificationSeen.js.map